module.exports = __webpack_public_path__ + "img/pinkTulip.4aa04a36.jpg";